import { render } from "./ChangeSingleFiderData.vue?vue&type=template&id=504f9e6d&lang=true"
import script from "./ChangeSingleFiderData.vue?vue&type=script&lang=js"
export * from "./ChangeSingleFiderData.vue?vue&type=script&lang=js"

import "./ChangeSingleFiderData.vue?vue&type=style&index=0&id=504f9e6d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__